import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFormatLineSpacingComponent } from "./med-icon-format-line-spacing.component";

@NgModule({
  declarations: [
    MedIconFormatLineSpacingComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFormatLineSpacingComponent,
  ],
})
export class MedIconFormatLineSpacingModule { }
